var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter } from '@angular/core';
import { Permission } from '../../common/enums/permission.enum';
import { CommonService } from '../../shared/services/common.service';
import { ViewTabModel } from '../interface/ticketingsystem/view-tab-model';
import { DeleteModal } from '../models/delete-modal';
import { CommonMessage } from '../common/common-messages';
import { MessageService } from '../../shared/services/message.service';
import { CookieService } from 'ngx-cookie-service';
import { Constants, MemberType, IsoCodeThree } from '../common/constants';
import { DataShareService } from '../../shared/services/data.service';
import { TicketsComponent } from './tickets.component';
import { OrderInfoTab } from '../models/order-info-tab-model';
import { TicketTabInfo } from '../models/tickets-tab.model';
import { MemberNotesComponent } from './member-notes.component';
import { environment } from '../../../environments/environment';
import { MemberActivityLogComponent } from './member-activity-logs.component';
import { Tabber } from '../enums/tabber';
import { TranslateService } from '@ngx-translate/core';
import { DownlineMapComponent } from './downline-map.component';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { MasterReportsComponent } from './master-reports.component';
import { TabConstants } from '../constants/tab.constants';
import { TabsetComponent } from 'ngx-bootstrap/tabs/tabset.component';
import { CustomerService } from '../services/customer.service';
import { CartTypes } from '../enums/cart-type.enum';
import { CacheService } from '../../shared/services/cache.service';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { OrderHistoryComponent } from './orderhistory.component';
import { MemberEmailLogComponent } from './member-email-log.component';
import { MemberDocumentsComponent } from './member-documents.component';
var FBODetailComponent = /** @class */ (function () {
    function FBODetailComponent(_commonService, _dataShareService, _cacheService, messageService, _translatePipe, _customerservice) {
        this._commonService = _commonService;
        this._dataShareService = _dataShareService;
        this._cacheService = _cacheService;
        this.messageService = messageService;
        this._translatePipe = _translatePipe;
        this._customerservice = _customerservice;
        this.tabs = new Array();
        this.existedValues = new Array();
        this.justifyingTabs = false;
        this.showAutoShip = false;
        this.showPaymentMethods = false;
        this.showDownline = false;
        this.isDistributor = false;
        this.isFBO = false;
        this.isFPC = false;
        this.orderHistoryTabs = new Array();
        this.ticketTabs = new Array();
        this.FBODetailPermissions = [Permission.FBO_PROFILE_VIEW, Permission.FBO_ORDER_HISTORY_VIEW,
            Permission.FBO_AUTOSHIP_DETAILS_VIEW, Permission.FBO_PAYMENT_METHODS_VIEW,
            Permission.FBO_DOWNLINE_VIEW, Permission.FBO_REPORTS_VIEW,
            Permission.MANAGE_TICKETS_VIEW,
            Permission.MANAGE_TICKETS_CREATE, Permission.MEMBER_NOTES_VIEW, Permission.MEMBER_ACTIVITY_LOG_VIEW];
        this.memberEmailViewTabs = new Array();
        this.customerServiceAccessLevelId = AccessLevel.Customer_Service;
        this.shoppingCartCount = 0;
        this.memberCartSessionFallBackCount = 0;
        this.isGuest = false;
        this.tabber = Tabber;
        this.cookieService = new CookieService(document);
        this.closeTabForFboID = new EventEmitter();
    }
    FBODetailComponent.prototype.ngOnInit = function () {
        if (environment.dataLayer && environment.dataLayer.length > 0) {
            environment.dataLayer[0].pageCategory = 'fbo-detail-page';
        }
        this.tabModel = new ViewTabModel();
        this.subscribeTabContent();
        this.subscribeClosedTabs();
        this.subscribeTabs();
        // if(!this.isNewOrder && this.isNewOrder === false){
        this.subscribeOrderHistoryTab();
        // }
        var isFboProfile = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[0] + ']'), AccessLevel.Customer_Service);
        var isFboOrder = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[1] + ']'), AccessLevel.Customer_Service);
        var isFboAutoship = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[2] + ']'), AccessLevel.Customer_Service);
        var isFboPayment = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[3] + ']'), AccessLevel.Customer_Service);
        var isFboDownline = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[4] + ']'), AccessLevel.Customer_Service);
        var isFboReports = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[5] + ']'), AccessLevel.Customer_Service);
        var isFboTickets = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[6] + ']'), AccessLevel.Customer_Service);
        var isFboTicketCreate = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[7] + ']'), AccessLevel.Customer_Service);
        var isMemberAttachments = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[8] + ']'), AccessLevel.Customer_Service);
        var isMemberActivityLog = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[9] + ']'), AccessLevel.Customer_Service);
        // Based on permissions updating active tab
        this.activetab = isFboProfile ? Tabber.FBOProfile : (isFboOrder ? Tabber.OrderHistory : (isFboAutoship ? Tabber.Autoship : (isFboPayment ? Tabber.PaymentMethods : (isFboDownline ? Tabber.Downline : (isFboReports ? Tabber.Tab6 : (isFboTickets ? Tabber.Tickets : (isMemberAttachments ? Tabber.Notes : (isMemberActivityLog ? Tabber.ActivityLog : Tabber.FBOProfile))))))));
        // this.route.params.subscribe((params: Params) => {
        //     this.fboid = params["id"];
        // });
        this.fboid = this.fboinputvalue;
        if (isFboOrder && this.country && (this.orderNumber || this.webOrderNumber || this.isNewOrder)) {
            var orderInfo = new OrderInfoTab();
            orderInfo.distributorID = this.fboinputvalue;
            orderInfo.homeCountry = this.country;
            orderInfo.orderID = !this.isNewOrder ? this.orderNumber : '';
            orderInfo.webOrderID = this.webOrderNumber;
            var isFromTitan = this.isNewOrder;
            if (isFromTitan) {
                orderInfo.recentOrder = true;
            }
            else {
                orderInfo.recentOrder = false;
            }
            this.addToOrderViewList(orderInfo);
        }
        this.subscribeTicketTabClose();
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.subscribeMemberEmailViewTab();
        this.getAllCountriesInfo();
        this.viewShoppingBagPermission = this._commonService
            .checkPermissionByAccessLevel(JSON.parse('[' + Permission.VIEW_SHOPPING_BAG + ']'), AccessLevel.Customer_Service);
    };
    FBODetailComponent.prototype.ngOnChanges = function (changes) {
        var isFboOrder = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[1] + ']'), AccessLevel.Customer_Service);
        this.orderNumber = changes['orderNumber'] ? changes['orderNumber'].currentValue : this.orderNumber;
        this.webOrderNumber = changes['webOrderNumber'] ? changes['webOrderNumber'].currentValue : this.webOrderNumber;
        this.country = changes['country'] ? changes['country'].currentValue : this.country;
        this.isNewOrder = changes['isNewOrder'] ? changes['isNewOrder'].currentValue : this.isNewOrder;
        if (isFboOrder && this.country && (this.webOrderNumber || this.orderNumber || this.isNewOrder)) {
            var orderInfo = new OrderInfoTab();
            orderInfo.distributorID = this.fboinputvalue;
            orderInfo.homeCountry = this.country;
            orderInfo.orderID = !this.isNewOrder ? this.orderNumber : '';
            orderInfo.orderNumber = this.orderNumber;
            orderInfo.webOrderID = this.webOrderNumber;
            if (this.isNewOrder) {
                orderInfo.recentOrder = true;
            }
            else {
                orderInfo.recentOrder = false;
            }
            this.addToOrderViewList(orderInfo);
        }
    };
    FBODetailComponent.prototype.ngAfterViewInit = function () {
        // Move page to top
        window.scrollTo(0, 0);
    };
    /**
     * @description
     * @date 2019-07-15
     * @memberof MemberEmailViewTabComponent
     */
    FBODetailComponent.prototype.subscribeMemberEmailViewTab = function () {
        var _this = this;
        this.memberEmailViewTabSubscription = this.messageService.getMemberEmailViewTab()
            .subscribe(function (memberEmailInfo) {
            if (memberEmailInfo && memberEmailInfo.distributorInfo
                && memberEmailInfo.distributorInfo.distributorId === _this.fboinputvalue) {
                _this.addMemberEmailViewTab(memberEmailInfo);
            }
        });
    };
    FBODetailComponent.prototype.getMemberDetails = function () {
        var _this = this;
        this._customerservice.getMemberDetails(this.fboid).subscribe(function (response) {
            var memberDoc = response.memberDocuments[0] ? true : false;
            if (memberDoc) {
                _this.memberDocument = true;
            }
            else {
                _this.memberDocument = false;
            }
        });
    };
    /**
     * @description
     * @date 2019-07-15
     * @param {MemberEmailViewTab} memberEmailViewTab
     * @memberof MemberEmailViewTabComponent
     */
    FBODetailComponent.prototype.addMemberEmailViewTab = function (memberEmailInfo) {
        this.memberEmailViewTabs = [];
        var memberEmailTab = this.memberEmailViewTabs.find(function (x) { return x.tabId === memberEmailInfo.memberEmailLog.id; });
        var title = this._translatePipe.get('customer-service.Sent Email')['value'];
        if (!memberEmailTab) {
            var memberEmailViewTab = {
                componentName: 'memberEmailViewTab',
                title: title,
                tabId: memberEmailInfo.memberEmailLog.id,
                active: true,
                memberEmailInfo: memberEmailInfo,
                disabled: false,
                removable: true,
                closeNewEmailViewTab: false
            };
            this.memberEmailViewTabs.push(memberEmailViewTab);
            this.alignTabs();
        }
        else {
            this.memberEmailViewTabs.forEach(function (x) {
                if (x.tabId === memberEmailInfo.memberEmailLog.id) {
                    x.active = true;
                }
                else {
                    x.active = false;
                }
            });
        }
    };
    /**
     * @description
     * @date 2019-07-15
     * @param {MemberEmailViewTab} tab
     * @memberof MemberEmailViewTabComponent
     */
    FBODetailComponent.prototype.removeMemberEmailViewTab = function (tab) {
        if (this.memberEmailViewTabs) {
            this.memberEmailViewTabs.splice(this.memberEmailViewTabs.indexOf(tab), 1);
            this.alignTabs();
            // Tab behavior
            this.activetab = 10;
            var tabIndex = this.staticTabs.tabs.findIndex(function (item) { return item.id === TabConstants.MEMBER_EMAIL; });
            this.staticTabs.tabs[tabIndex].active = true;
        }
    };
    /**
     * @description
     * @date 2020-03-05
     * @memberof FBODetailComponent
     */
    FBODetailComponent.prototype.createTicket = function () {
        this.activetab = Tabber.Notes;
        this.showCreateTicketTab = true;
    };
    /**
     * @description
     * @date 2020-03-05
     * @memberof FBODetailComponent
     */
    FBODetailComponent.prototype.activeTicketTab = function () {
        this.activetab = Tabber.Tickets;
        this.selectTab(Tabber.Tickets);
    };
    /**
     * @description
     * @date 2020-03-05
     * @param {*} tab
     * @memberof FBODetailComponent
     */
    FBODetailComponent.prototype.selectTab = function (tab) {
        this.activetab = tab;
        if (tab === Tabber.Tickets && this.ticketsComponent) {
            this.ticketsComponent.ngOnInit();
        }
        if (tab === Tabber.Reports && this.downlineMapComponent) {
            this.downlineMapComponent.ngOnInit();
        }
        if (tab === Tabber.OrderHistory || tab === Tabber.FBOProfile) {
            if (this._cacheService.get(CacheKey.CARTUPDATED)) {
                this.shoppingCartCount = 0;
                this.memberCartSessionFallBackCount = 0;
                this.savedBagCountry = null;
                this.getStoreInfo();
                this._cacheService.remove(CacheKey.CARTUPDATED);
            }
            if (tab === Tabber.OrderHistory && this.orderHistoryComponet) {
                if (this._cacheService.get(CacheKey.ORDERTABREFRESH)) {
                    this.orderHistoryComponet.getRecentOrders();
                    this._cacheService.remove(CacheKey.ORDERTABREFRESH);
                }
            }
        }
        if (tab === Tabber.Emails && this.memberEmailLogComponent) {
            this.memberEmailLogComponent.emailLogSearch();
        }
    };
    /**
     * @description
     * @date 2020-03-05
     * @memberof FBODetailComponent
     */
    FBODetailComponent.prototype.activeNotesTab = function () {
        this.activetab = Tabber.Notes;
        this.selectTab(Tabber.Notes);
    };
    FBODetailComponent.prototype.changeTab = function (tab) {
        this.activetab = tab;
    };
    FBODetailComponent.prototype.subscribeTabContent = function () {
        var _this = this;
        this.messageService.getCustomerServiceUserTabContent().subscribe(function (data) {
            _this.addToTicketTabs(data);
        });
    };
    FBODetailComponent.prototype.addToTicketTabs = function (data) {
        if ((this.ticketTabs.length + this.orderHistoryTabs.length) < Constants.MaximumTablsTicketOrderLength) {
            if (data && data.distributorID === this.fboinputvalue) {
                this.activetab = 0;
                this.orderHistoryTabs.forEach(function (tab) { return tab.active = false; });
                this.ticketTabs.forEach(function (tab) { return tab.active = false; });
                var ticketTab = this.ticketTabs.find(function (tab) { return tab.ticketID === data.ticketID; });
                if (data.editTicket) {
                    this.removeTicketTab(ticketTab);
                }
                if (data.viewTicket && ticketTab && ticketTab.viewTicket) {
                    this.ticketTabs.forEach(function (tab) { if (tab.ticketID === data.ticketID && tab.viewTicket === true) {
                        tab.active = true;
                    } });
                }
                else {
                    data.active = true;
                    data.disabled = false;
                    data.removable = true;
                    this.ticketTabs.push(data);
                    this.alignTabs();
                }
                // observable event to display close all open tabs link in ui in search screen (For SearchComponent)
                this.messageService.setOpenTabsInfo((this.tabs && this.tabs.length) ? true : false);
            }
        }
        else {
            this.displayAlertBoxOnReachingMaxTabs();
        }
    };
    /**
      * To get Tabs information (AS of now-- true / false) -- True refers there are opened tabs
    */
    FBODetailComponent.prototype.subscribeClosedTabs = function () {
        var _this = this;
        this.messageService.getCloseTabsEvent().subscribe(function (data) {
            if (data) {
                _this.closeAllOpenedTabs();
            }
        });
    };
    FBODetailComponent.prototype.closeTab = function (tabName) {
        if (tabName === 'Autoship') {
            this.showAutoShip = false;
        }
        else if (tabName === 'PaymentMethods') {
            this.showPaymentMethods = false;
        }
        else if (tabName === 'Downline') {
            this.showDownline = false;
        }
        this.selectTab(1);
    };
    FBODetailComponent.prototype.subscribeTabs = function () {
        var _this = this;
        this.messageService.getTabs().subscribe(function (tab) {
            if (tab && tab.fboId === _this.fboid) {
                if (tab.tabName === 'Autoship') {
                    _this.showAutoShip = true;
                    _this.selectTab(Tabber.Autoship);
                }
                else if (tab.tabName === 'PaymentMethods') {
                    _this.showPaymentMethods = true;
                    _this.selectTab(Tabber.PaymentMethods);
                }
                else if (tab.tabName === 'Downline') {
                    _this.showDownline = true;
                    _this.selectTab(Tabber.Downline);
                }
            }
        });
    };
    FBODetailComponent.prototype.addNewTab = function () {
        var _this = this;
        var newTabIndex = this.tabs.length + 1;
        this.tabModel = new ViewTabModel();
        this.id = this.tabs.length !== 0 ? this.tabs[this.tabs.length - 1].id + 1 : newTabIndex;
        this.tabModel.id = this.id;
        this.tabModel.ticketId = this.ticketId;
        this.tabModel.isView = this.isView;
        this.tabModel.title = this.tabTitle;
        this.tabModel.disabled = false;
        this.tabModel.removable = true;
        this.tabModel.active = true;
        this.activetab = 0;
        this.tabModel.componentName = this.componentName;
        this.existedValues = new Array();
        var tabOpen = this.tabs.find(function (tab) { return tab.ticketId && tab.ticketId === _this.ticketId; });
        if (this.tabs.length === Constants.MaximumTabsLength) {
            // need to display information -- as you reached maxiumum number of tabs.
            // this.tabs.splice(0, 1);
            this.displayAlertBoxOnReachingMaxTabs();
        }
        else {
            if (!tabOpen) {
                this.tabs.push(this.tabModel);
            }
            else {
                var selectedId_1 = tabOpen.id;
                this.tabs.forEach(function (x) {
                    if (x.id !== selectedId_1) {
                        x.active = false;
                    }
                    else {
                        x.active = true;
                    }
                });
            }
        }
    };
    /**
     * removes tab at specific index
     * @param tab
     */
    FBODetailComponent.prototype.removeTabHandler = function (tab) {
        if (this.tabs) {
            this.tabs.splice(this.tabs.indexOf(tab), 1);
            this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
            this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
        }
    };
    /**
     * Close all opened tabs
     */
    FBODetailComponent.prototype.closeAllOpenedTabs = function () {
        this.tabs = []; // new Array<DynamicTabModel>();
        this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
        this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
        // this.messageService.setOpenTabsInfo((this.tabs && this.tabs.length) ? true : false);
    };
    /**
     * display alert box on reaching maximum no of tabs = 8
     */
    FBODetailComponent.prototype.displayAlertBoxOnReachingMaxTabs = function () {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.tabsTicketOrderMessage;
    };
    FBODetailComponent.prototype.getDistributorInfo = function (distributorDetails) {
        this.distributorInfo = distributorDetails && !!Object.keys(distributorDetails).length ? __assign({}, distributorDetails) : distributorDetails;
        this.setDistributorFlag(distributorDetails.memberTypeId);
        this.setFBOFlag(this.memberType);
        this.getMemberDetails();
    };
    FBODetailComponent.prototype.setDistributorFlag = function (memberTypeId) {
        if (memberTypeId === MemberTypeEnum.DISTRIBUTOR) {
            this.isDistributor = true;
        }
    };
    FBODetailComponent.prototype.setFBOFlag = function (memberType) {
        if (memberType === MemberType.FOB) {
            this.isFBO = true;
        }
        if (memberType === MemberType.PREFERREDCUSTOMER || memberType === MemberType.FPC || memberType === MemberType.PREFERRED_CUSTOMER) {
            this.isFPC = true;
        }
        if (memberType === MemberType.GUEST || this.distributorInfo.memberType === MemberType.GUEST) {
            this.isGuest = true;
        }
    };
    FBODetailComponent.prototype.getAutoshipTabInfo = function (autoshipTabInfo) {
        this.autoshipTabInfo = autoshipTabInfo;
    };
    FBODetailComponent.prototype.getHomeCountryInfo = function (homeCountryInfo) {
        this.homeCountryInfo = homeCountryInfo;
        this.memberCartSessionFallBackCount = 0;
        this.shoppingCartCount = 0;
        this.getStoreInfo();
    };
    FBODetailComponent.prototype.getOperatingCountryInfo = function (operatingCountryInfo) {
        this.operatingCountryInfo = operatingCountryInfo;
    };
    /**
     * set member Id for Autoships tab
     */
    FBODetailComponent.prototype.setMemberId = function (memberId) {
        this.memberId = memberId;
    };
    FBODetailComponent.prototype.addToOrderViewList = function (data) {
        if ((this.ticketTabs.length + this.orderHistoryTabs.length) < Constants.MaximumTablsTicketOrderLength) {
            var tab = this.orderHistoryTabs.find(function (tab) { return (tab.webOrderID && tab.webOrderID === data.webOrderID || (tab.orderID && data.orderID && tab.orderID === data.orderID)); });
            tab ? '' : this.orderHistoryTabs.find(function (tab) { return tab.newOrder === true; });
            this.orderHistoryTabs.forEach(function (orderTab) { return orderTab.active = false; });
            if (tab) {
                this.activetab = 0;
                tab.active = true;
            }
            else {
                var orderInfo = new OrderInfoTab();
                if (!data.newOrder) {
                    orderInfo.distributorID = data.distributorID;
                    orderInfo.homeCountry = data.homeCountry;
                    orderInfo.orderID = data.orderID;
                    orderInfo.orderNumber = data.orderNumber;
                    orderInfo.webOrderID = data.webOrderID;
                    orderInfo.retailID = data.retailID;
                    if (data.webOrderID) {
                        orderInfo.title = data.webOrderID; // "Order - " +
                    }
                    else if (data.orderID) {
                        orderInfo.title = data.orderID; // "Order - " +
                    }
                    else {
                        orderInfo.title = data.orderNumber; // "Order - " +
                    }
                    orderInfo.componentName = 'orderViewTab';
                    orderInfo.recentOrder = data.recentOrder;
                    // orderInfo.newOrder = this.isNewOrder === true ? false:true;
                }
                else {
                    orderInfo.title = 'Create Order';
                    orderInfo.newOrder = true;
                }
                orderInfo.active = true;
                this.activetab = 0;
                orderInfo.disabled = false;
                orderInfo.removable = true;
                this.orderHistoryTabs.push(orderInfo);
                this.alignTabs();
            }
            // observable event to display close all open tabs link in ui in search screen (For SearchComponent)
            this.messageService.setOpenTabsInfo((this.tabs && this.tabs.length) ? true : false);
        }
        else {
            this.displayAlertBoxOnReachingMaxTabs();
        }
    };
    FBODetailComponent.prototype.subscribeOrderHistoryTab = function () {
        var _this = this;
        this.messageService.getOrderHistoryTab().subscribe(function (data) {
            if (data && data.distributorID === _this.fboinputvalue) {
                if (!data.closeNewOrderTab) {
                    _this.addToOrderViewList(data);
                }
                else {
                    var tab = _this.orderHistoryTabs.find(function (tab) { return tab.newOrder === true; });
                    var orderInfo = new OrderInfoTab();
                    orderInfo.componentName = 'orderViewTab';
                    orderInfo.webOrderID = data.webOrderID;
                    orderInfo.distributorID = data.distributorID;
                    orderInfo.orderID = data.orderID;
                    orderInfo.title = 'Order - ' + data.webOrderID;
                    orderInfo.recentOrder = true;
                    orderInfo.active = true;
                    _this.activetab = 0;
                    orderInfo.disabled = false;
                    orderInfo.removable = true;
                    orderInfo.homeCountry = data.homeCountry;
                    _this.orderHistoryTabs.push(orderInfo);
                    _this.alignTabs();
                    _this.removeOrderTab(tab);
                }
            }
        });
    };
    /**
     * removes orders tab at specific index
     * @param tab
     */
    FBODetailComponent.prototype.removeOrderTab = function (tab) {
        if (this.orderHistoryTabs) {
            this.orderHistoryTabs.splice(this.orderHistoryTabs.indexOf(tab), 1);
            this.alignTabs();
            // Tab behavior
            this.activetab = 2;
            var tabIndex = this.staticTabs.tabs.findIndex(function (item) { return item.id === TabConstants.ORDER_HISTORY; });
            this.staticTabs.tabs[tabIndex].active = true;
        }
    };
    /**
     * @description
     * @date 2020-03-05
     * @param {*} tab
     * @memberof FBODetailComponent
     */
    FBODetailComponent.prototype.removeTicketTab = function (tab) {
        if (this.ticketTabs) {
            this.ticketTabs.splice(this.ticketTabs.indexOf(tab), 1);
            this.alignTabs();
            // Tab behavior
            this.activetab = 7;
            if (this.subscribeTabs && this.staticTabs.tabs && this.staticTabs.tabs.length > 0) {
                var tabIndex = this.staticTabs.tabs.findIndex(function (item) { return item.id === TabConstants.CUSTOMER_TICKET; });
                this.staticTabs.tabs[tabIndex].active = true;
            }
        }
    };
    FBODetailComponent.prototype.subscribeTicketTabClose = function () {
        var _this = this;
        this.messageService.getClosingTabInfo().subscribe(function (data) {
            if (data && (data.distributorID === _this.fboinputvalue)) {
                _this.ticketTabs.forEach(function (tickeTab) { return tickeTab.active = false; });
                if (_this.ticketTabs.length > 0) {
                    var tab = _this.ticketTabs[data.tabIndex];
                    _this.removeTicketTab(tab);
                    _this.alignTabs();
                }
                if (!data.modifiedDistributor) {
                    _this.goToTicketView(data.ticketID, data.ticketNumber);
                }
                else {
                    _this.selectTab(1);
                }
            }
        });
    };
    /**
    * Navigate to ticket view tab
    */
    FBODetailComponent.prototype.goToTicketView = function (ticketId, ticketNumber) {
        var ticketTab = new TicketTabInfo();
        ticketTab.distributorID = this.fboid;
        ticketTab.isNewTicket = false;
        ticketTab.ticketID = ticketId;
        ticketTab.title = 'View Ticket - ' + ticketNumber;
        ticketTab.viewTicket = true;
        this.addToTicketTabs(ticketTab);
    };
    /**
    * on clicking of "No" this method will be called.
    */
    FBODetailComponent.prototype.doNotRemoveFormData = function () {
        // data should not be removed...
    };
    FBODetailComponent.prototype.ngOnDestroy = function () {
        if (this.memberEmailViewTabSubscription) {
            this.memberEmailViewTabSubscription.unsubscribe();
        }
    };
    /**
     * @description To align tab content top
     * @date 2020-01-29
     * @memberof FBODetailComponent
     */
    FBODetailComponent.prototype.alignTabs = function () {
        setTimeout(function () {
            var element = document.querySelector('.active .cs-secondary-tabs.nav  > .nav-tabs');
            var tabContentElement = document.querySelector('.active .cs-secondary-tabs.nav > .tab-content');
            if (element && tabContentElement) {
                var tabsHeight = element.offsetHeight;
                tabContentElement.style.marginTop = (tabsHeight + 3) + 'px';
            }
        }, 100);
    };
    /**
     * @description get store info
     * @date 2020-04-03
     * @memberof FBODetailComponent
     */
    FBODetailComponent.prototype.getStoreInfo = function () {
        var _this = this;
        if (this.homeCountryInfo) {
            this._customerservice.getStoreInfoFromConfig(this.homeCountryInfo)
                .subscribe(function (response) {
                if (response) {
                    _this.storeInfo = response;
                    if (_this.distributorInfo) {
                        _this.distributorInfo = __assign({}, _this.distributorInfo, { displayMiddleName: _this.storeInfo.displayMiddleName });
                    }
                    _this.getMemberCart(_this.storeInfo);
                }
            }, function (err) {
                _this.getMemberCartFallBack();
            });
        }
    };
    /**
     * @description get members cart count and cart
     * @date 2020-04-03
     * @param {StoreConfig} storeInfo
     * @memberof FBODetailComponent
     */
    FBODetailComponent.prototype.getMemberCart = function (storeInfo) {
        var _this = this;
        this._customerservice.getCartItemsByMemberIdAndCartType(this.distributorInfo.memberId, CartTypes.OrderCart, storeInfo).subscribe(function (response) {
            if (response && response.sessionGuid && response.items && response.items.length) {
                _this.shoppingCart = response;
                _this.shoppingCartCount = 0;
                response.items.forEach(function (item) {
                    _this.shoppingCartCount += item.quantity;
                });
            }
            else {
                _this.getMemberCartFallBack();
            }
        }, function (error) {
            new Error(error);
        });
    };
    /**
     * @description fallback for non-titan home country members
     * @date 2020-04-03
     * @memberof FBODetailComponent
     */
    FBODetailComponent.prototype.getMemberCartFallBack = function () {
        var _this = this;
        var countries = this.titanEnabledCountries.filter(function (item) {
            return item.isocodeThree.toUpperCase() !== _this.homeCountryInfo.toUpperCase();
        });
        if (countries && countries.length && this.memberCartSessionFallBackCount < countries.length) {
            var fallbackCountry = countries[this.memberCartSessionFallBackCount];
            this.savedBagCountry = fallbackCountry.countryId;
            this._customerservice.getStoreInfoFromConfig(fallbackCountry.isocodeThree)
                .subscribe(function (response) {
                if (response) {
                    _this.getMemberCart(response);
                    _this.memberCartSessionFallBackCount++;
                }
            });
        }
    };
    /**
     * @description get all titan countries
     * @date 2020-04-03
     * @memberof FBODetailComponent
     */
    FBODetailComponent.prototype.getAllCountriesInfo = function () {
        var _this = this;
        this._customerservice.getAllCountries(true).subscribe(function (response) {
            if (response) {
                _this.titanEnabledCountries = response.filter(function (country) { return country.isocodeThree
                    === IsoCodeThree.USA || country.isocodeThree === IsoCodeThree.CAN; });
            }
        });
    };
    /**
     * @description cache the shopping cart to open new tab
     * @date 2020-04-03
     * @memberof FBODetailComponent
     */
    FBODetailComponent.prototype.gotoCheckout = function () {
        if (this.shoppingCartCount) {
            this._cacheService.set('CreateOrderInfo', {
                distributorId: this.fboid, shoppingCart: this.shoppingCart,
                shoppingBagClicked: true,
                countryId: this.savedBagCountry
            });
        }
    };
    FBODetailComponent.prototype.closeTabForParticularDistributor = function ($event) {
        var distributorId = $event;
        this.closeTabForFboID.emit(distributorId);
    };
    return FBODetailComponent;
}());
export { FBODetailComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/fbodetail.component.ts.pre-build-optimizer.js